import createVueApp from '@/common/create_app'

Styxie.Initializers.ExifTemplates = {
  index: async(props) => {
    const { default: ExifTemplatesIndex } = await import('@/vue_widgets/exif_templates/index.vue')
    createVueApp(ExifTemplatesIndex, { props })
  },
  new: async(props) => {
    const { default: ExifTemplateForm } = await import('@/vue_widgets/exif_templates/form/index.vue')
    createVueApp(ExifTemplateForm, { props })
  },
  edit: async(props) => {
    const { default: ExifTemplateForm } = await import('@/vue_widgets/exif_templates/form/index.vue')
    createVueApp(ExifTemplateForm, { props })
  }
}
